/**
 * Created by wangmc on 2018/3/13.
 */

 import {domain, SGPOSTFIX, port, sghost, WXAUTOLOGINURL, TELDAPPID, MALLAPPID} from "./env";
 import {
     readCookie,
     createCookie,
     eraseCookie,
     setSessionStore,
     getSessionStore,
     encryptedString,
     encryptByDESModeCBC,
     getAppDevice,
     getDevice,
     isFunction,
     isAbsoluteURL,
     isSID,
     cajessInside,
     cajessOutside,
     dcajessInside,
     dcajessOutside,
     GetWxCode,
     getUrlQuery
 } from './method'
 import wxsdk from '../lib/jweixin.min'
 // 引用axios
 const axios = require('axios')
 
 const isInMinPro = getUrlQuery('t') === 'sp'||getUrlQuery('t') === 'sp1' //判断小程序环境
 const isInMinProNoIndentify = getUrlQuery('t') === 'sp1'//小程序没有身份
 
 const isInApp = getAppDevice()
 const appVersion = readCookie('ta_appVersion')
 let refreshState = {
     count: 0,
     promise: void 0,
     askForDeviceInfo: void 0,
     alogin: void 0
 }
 const baseURL = `//${sghost + domain + port}`
 
 const ASLOGIN = 'UserAPI-WEBUI-ASLogin'//`//userapisg${domain}/api/invoke?SID=UserAPI-WEBUI-ASLogin`//
 const SREFRESHTOKEN = 'UserAPI-WEBUI-SRefreshToken'//`//userapisg${domain}/api/invoke?SID=UserAPI-WEBUI-SRefreshToken`//
 const ASREFRESHTOKEN = 'UserAPI-WEBUI-ASRefreshToken'//`//userapisg${domain}/api/invoke?SID=UserAPI-WEBUI-ASRefreshToken`//
 
 const lon = 60000
 
 let axiosIntercept = {
     request: void 0,
     response: void 0,
     login: void 0
 }
 
 function randomUrl(url) {
     if (!url) return null
     if (!isAbsoluteURL(url) && isSID(url)) url = SGPOSTFIX + url
     // url += `${url.indexOf('?') > -1 ? '&' : '?'}r=${Math.random()}`
     return url
 }
 
 function formatData(data) {
     if (typeof data == 'object') {
         let arr = []
         for (let name in data) {
             arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(data[name]))
         }
         return arr.join("&")
     } else {
         return data
     }
 }
 
 function getIP() {
     return readCookie("teldz")
 }
 
 function setTimeDif(time) {
     let dtime = Math.round(new Date().getTime() / 1000)
     if (time) {
         let ttt = time - dtime;
         setSessionStore("teldTTT", ttt)
     }
 }
 
 async function _appSgParamSetting(data) {
     let deviceInfo = readCookie('twf_deviceInfo')
     if (!deviceInfo) {
         if (refreshState.askForDeviceInfo) {
             await refreshState.askForDeviceInfo
             refreshState.askForDeviceInfo = null
         } else {
             refreshState.askForDeviceInfo = new Promise(function (resolve, reject) {
                 try {
                     $teld.askForDeviceInfo(function (res) {
                         if (res) {
                             deviceInfo = res
                             res = encodeURIComponent(res)
                             createCookie('twf_deviceInfo', res, 50)
                         }
                         resolve()
                     })
 
                 } catch (e) {
                     reject(e)
                 }
             })
             await refreshState.askForDeviceInfo
             refreshState.askForDeviceInfo = null
         }
     } else {
         deviceInfo = decodeURIComponent(deviceInfo)
     }
     deviceInfo = decodeURIComponent(readCookie("twf_deviceInfo"))
     if (!deviceInfo) return
     let dInfo = deviceInfo.split(",")
     //来源设备IP
     data["ASDI"] = dInfo[0]
     //时间戳明
     data["ATS"] = dInfo[1]
     //时间戳密文
     data["AVER"] = dInfo[2]
     //定位城市
     data["ACOL"] = dInfo[3]
     //城市名称
     data["ACOI"] = dInfo[4]
     //来源
     data["ARS"] = "APP"
 }
 
 function _webSgParamSetting(data) {
 
     let ip = getIP()
 
     let dtime = Math.round(new Date().getTime() / 1000)
 
 
     //需要时间校准    客服端跟服务端的时间差
     let ttt = getSessionStore("teldTTT") || 0
      if(!isNaN(ttt)){
        dtime += new Number(ttt)
      }
     let dt = encryptedString(dtime + "")
 
     if (isInMinPro) {
 
         // //时间戳明文
         data["STS"] = dtime
         //时间戳密文
         // data["SVER"] = dt
         data["SVER"] = encryptByDESModeCBC({data: dtime + ""})
         //来源设备IP
         data["SSDI"] = ip
         //来源
         data["SRS"] = "SP"
         //城市名称
         data["SCOI"] = ""
         //定位城市
         data["SCOL"] = ""
 
     } else {
         //时间戳明文
         data["WTS"] = dtime
         //时间戳密文
         data["WVER"] = dt
         //来源设备IP
         if (!ip) {  //解决电商反馈teldz丢失情况，从身份中取
             try {
                 let idParams = readCookie("telda") || readCookie("teldk");
                 if(idParams){
                     idParams = decode64(idParams.split('.')[1])
                     //最后一个括号的位置，windows解析出来的string最后带有空占位符。直接parse报错
                     idParams = JSON.parse(idParams.substring(0, idParams.lastIndexOf('}') + 1));
                     ip = idParams.client_ip;
                 }
             } catch (err) {
                 console.log(err)
             }
         }
         data["WSDI"] = ip
         //来源
         data["WRS"] = "WEB"
         //城市名称
         data["WCOI"] = ""
         //定位城市
         data["WCOL"] = ""
     }
 }
 
 function sgParamSetting(data) {
     // && (readCookie('telda') || appVersion >= '4.0.0')
     if (isInApp)
         return _appSgParamSetting(data)
     else
         _webSgParamSetting(data)
 }
 
 function refreshToken_app() {
     return new Promise(function (resolve, reject) {
         try {
             $teld.askForToken(function (accessToken, refreshToken) {
                 if (accessToken) {
                     let TokenType = readCookie('teldc')
                     if (TokenType == '1') {
                         createCookie("teldk", accessToken, 1000)
                         createCookie("teldc", TokenType, 2000)
                     } else {
                         createCookie("telda", accessToken, 1000)
                     }
                     createCookie("teldb", refreshToken, 2000)
                     refreshState.count = 0
                 }
                 resolve()
             })
         } catch (e) {
             reject(e)
         }
     })
 }
 
 let spIslogin = false; //微信小程序已经跳转登陆页面，防止多次调用
 function goLogin(ret) {
     //app内嵌h5的场合，调用app跳登陆
     if (isInApp) {
         try {
             return $teld.goToLogin();
         } catch (e) {
             console.log(e)
         }
     } else {
         let isInMinProNoId = isInMinPro;//小程序无身份与有身份（判断是小程序环境）
         // removeSessionStore("teldTTT")
         if (readCookie('teldc') != '1') {
             eraseCookie("teldb")
             eraseCookie("teldc")
             eraseCookie("teldz")
         }
         eraseCookie("TELDSID")
         eraseCookie("telda")
         eraseCookie("teldk")
         if (getDevice() == 'wx' && !isInMinProNoId) {//微信环境
             let domain = document.domain;
             if (!domain.match('cv.')) return;  //非cv环境不走cv公共登录页面
             let url = `${WXAUTOLOGINURL}?from=${encodeURIComponent(window.location.href)}`
             let MPType = readCookie('TELD_MPType') || '1'
             let AppId = readCookie('TELD_MPType') == '2' ? MALLAPPID : TELDAPPID
             window.location.href = GetWxCode(AppId, url, MPType)
         } else if (getDevice() == 'wx' && isInMinProNoId && !spIslogin) { //微信小程序
             spIslogin = true;
             let loginPath = '/pages/PersonalCenter/Login/index';
             return wxsdk.miniProgram.navigateTo({url: loginPath})
         }
         else {
             isFunction(axiosIntercept.login) && axiosIntercept.login(ret);
         }
     }
 }
 
 async function monRefreshToken(call, ret, data) {
     if ((isInApp && refreshState.count > 1) || (!isInApp && !readCookie('teldb')) || refreshState.count > 2) {
         return goLogin(ret)
     } else {
         if (data['X-Token'] && data['X-Token'] != readCookie('telda') && data['X-Token'] != readCookie('teldk')) {
             return call()
         }
         eraseCookie('telda')
         eraseCookie('teldk')
         await refreshToken()
         call()
     }
 }
 
 async function refreshToken() {
     let tokenType = readCookie('teldc')
     let url = void 0
     if (tokenType == '1') {
         if (readCookie('teldk')) return
         url = ASREFRESHTOKEN
     } else {
         if (readCookie('telda')) return
         url = SREFRESHTOKEN
     }
     //app刷新token场景
     if (isInApp && (readCookie('teldc') != '1' || appVersion >= '4.0.0')) {
         if (refreshState.promise) {
             await refreshState.promise
             refreshState.promise = null
             return
         } else {
             refreshState.count++
             refreshState.promise = refreshToken_app()
             // return refreshState.promise
             await refreshState.promise
             refreshState.promise = null
             return
         }
     }
     let refresh = readCookie("teldb")
     if (!refresh) {
         return
     }
     let rToken = refresh.split(".").reverse().join(".")
     let ip = getIP()
     let refreshData = {
         'DeviceType': '',
         'ReqSource': '',
         'RefreshToken': rToken,
         'ClientIP': ip
     }
     if (isInMinPro) {
         refreshData.DeviceType = getUrlQuery('sp1')
         refreshData.ReqSource = getUrlQuery('sp3')
         refreshData.DeviceId = getUrlQuery('sp0')
     } else {
         refreshData.DeviceType = 'WEB'
         refreshData.ReqSource = 100
     }
     let data = {
         refreshToken: cajessInside(refreshData)
     }
 
 
     await sgParamSetting(data)
 
     if (refreshState.promise) {
         await refreshState.promise
         refreshState.promise = null
     } else {
         refreshState.count++
         refreshState.promise = axios({
             baseURL: baseURL,
             url: randomUrl(url),
             method: "POST",
             timeout: 10000,
             data: data,
             transformRequest: [function (data) {
                 return formatData(data)
             }],
             withCredentials: true,
             cache: false,
             validateStatus: function (status) {
                 return status <= 500 // 状态码在大于500时才会 reject
             }
         })
             .then(function (res) {
                 if (res.status >= 200 && res.status < 300) {
                     let rdata = res.data
                     if (rdata && rdata.state == '1') {
                         let realData = dcajessInside(rdata.data)
                         if (realData.TokenType == 1) {
                             createCookie("teldk", realData.AccessToken, realData.ExpiresIn);
                         } else {
                             createCookie("telda", realData.AccessToken, realData.ExpiresIn);
                         }
                         createCookie("teldb", realData.RefreshToken, lon);
                         createCookie("teldc", realData.TokenType, lon);
                         createCookie("teldz", readCookie("teldz"), lon);
                         refreshState.count = 0
                     }
                 }
             })
             .catch(function (e) {
                 console.log(e)
             })
         await refreshState.promise
     }
 }
 
 /***
  * 匿名登陆
  */
 async function aLogin(isRetry) {
     let aLoginData = {"DeviceType": "WEB", "ReqSource": 100, "ClientIP": getIP()}
     if (isInMinPro) {
         aLoginData = { "DeviceType": "SP", "ReqSource": 100, "DeviceId": getIP() }
     }
     let data = {
         loginInfo: cajessInside(aLoginData)
     }
 
     await sgParamSetting(data)
 
     if (refreshState.alogin) {
         await refreshState.alogin
         refreshState.alogin = null
     } else {
         refreshState.alogin = axios({
             baseURL: baseURL,
             url: randomUrl(ASLOGIN),
             method: "POST",
             timeout: 10000,
             data: data,
             transformRequest: [function (data) {
                 return formatData(data)
             }],
             withCredentials: true,
             cache: false,
             validateStatus: function (status) {
                 return status <= 500 // 状态码在大于500时才会 reject
             }
         })
             .then(function (res) {
                 if (res.status >= 200 && res.status < 300) {
                     let rdata = res.data
                     if (rdata && rdata.state == '1') {
                         let realData = dcajessInside(rdata.data)
                         createCookie("teldk", realData.AccessToken, realData.ExpiresIn);
                         createCookie("teldb", realData.RefreshToken, lon);
                         createCookie("teldc", realData.TokenType, lon);
                         createCookie("teldz", realData.ClientIP, lon);
                     } else {
                         let ErrorCode = rdata.hasOwnProperty("ErrorCode") ? rdata.ErrorCode : rdata.errcode
                         let ErrorInfo = rdata.hasOwnProperty("ErrorInfo") ? rdata.ErrorInfo : rdata.errmsg
                         if (ErrorCode == "TTP-SG-2003") {
                             // 时间戳不整合
                             let TTT = 0
                             if(ErrorInfo.indexOf(':')>0){
                                TTT = new Number(ErrorInfo && ErrorInfo.split(":")[1])
                             }
                             setTimeDif(TTT);
                             if (!isRetry) {
                                 refreshState.alogin = null
                                 return aLogin(true)
                             }
                         }
                     }
                 }
             })
             .catch(function (e) {
                 console.log(e)
             })
         await refreshState.alogin
         refreshState.alogin = null
     }
 }
 
 function apiAxiosRetry(opt, ErrorCode) {
     if (opt._isRetry === ErrorCode) return
     opt._isRetry = ErrorCode
     apiAxios(opt)
 }
 
 async function bindIndentity() {
     if (isInMinPro) {
         let teldb = getUrlQuery('sp2') || ''
         teldb = teldb.split(".").reverse().join(".")
         createCookie('teldb', teldb, lon)
         createCookie('teldz', getUrlQuery('sp0'), lon)
         eraseCookie('teldc')
     }
     if (isInMinPro){ //解决小程序登出FCP接口报错问题（TELDSID）
         if (readCookie('TELDSID')) {
             eraseCookie("TELDSID");
         }
         if (isInMinProNoIndentify && readCookie("telda")) {  //小程序登出后，h5内嵌页并没有清掉telda
             eraseCookie("telda");
         }
     }
 
     if (!readCookie('teldb') && !readCookie('teldz')) {
         eraseCookie('telda')
         eraseCookie('teldk')
     } else {
         if (readCookie("telda")) return
         await refreshToken()
         if (readCookie("telda") || readCookie('teldk')) return
     }
     //未获取到身份参数
     if (isInApp) {  //修改app未给h5传递身份时 请求来源不一致  bug
         await refreshToken()
     } else {
         //匿名登陆
         await aLogin();
     }
 }
 
 /**
  * 封装axios
  * @param {String} method    请求的类型，默认post
  * @param {String} url    请求地址（在config.js里配置）
  * @param {Object} data    请求参数
  * @param {Object} headers    自定义请求headers
  * @param {Int} timeout    超时时间
  * @param {Function} success    请求成功后，这里会有一个参数,服务器返回数据 data
  * @param {Function} failure    请求失败处理函数
  * @param {Boolean} withCredentials    跨域请求时是否传递cookie(默认true：传递)
  * @param {Boolean} noIdentity    是否验证身份（默认false:验证身份）
  * @param {Boolean} rsaData    是否加密参数（默认false:不加密）
  * @param {Boolean} isCoreSG    核心接口，入参加密，返回值解密（crypto方式，默认false:不加密）
  * @param return
  */
 async function apiAxios(opt) {
     if(opt.postData&&JSON.stringify(opt.postData) != '{}'){
         opt.data=JSON.parse(JSON.stringify(opt.postData))
     }
     opt.postData = JSON.parse(JSON.stringify(opt.data));
     let opts = opt || {}
     let url = randomUrl(opts.url)
     if (!url) return
     let data = opts.data || {}
     let rsaData = !!opts.rsaData
     if (rsaData) {
         // 参数RSA加密
         encryptedString(data)
     }
     let isCoreSG = !!opts.isCoreSG
     if (isCoreSG) {
         cajessOutside(data)
     }
 
     await bindIndentity()//还原身份
     let TELDAppID = ''//帮电商解决 teldappid问题
     if(readCookie('TELDAppID')&&window.location.hostname.indexOf('newmall')!=-1){
         TELDAppID = readCookie('TELDAppID')
         eraseCookie('TELDAppID')
     }
     // data['X-Token'] = xtoken
     data['X-Token'] = readCookie('telda') || readCookie('teldk')
     let method = opts.method || 'POST'
     method = method.toUpperCase()
 
     let params = opts.params
     if (method === 'GET') {
         params = Object.assign(data, params)
     }
 
     await sgParamSetting(data) //添加身份相关数据(app ios新框架增加了await)
 
     return axios({
         method: method,
         baseURL: data.baseURL || baseURL,
         url: url,
         data: data || null,
         params: params || null,
         transformRequest: [function (data) {
             return formatData(data)
         }],
         paramsSerializer: function (params) {
             return formatData(params)
         },
         headers: opts.headers || {'Content-Type': 'application/x-www-form-urlencoded'},
         timeout: opts.time || 120 * 1000,
         responseType: opts.dataType || 'json',
         withCredentials: opts.withCredentials === false ? false : true,
         cache: false,
         validateStatus: function (status) {
             return status <= 500 // 状态码在大于500时才会 reject
         }
     })
         .then(async function (res) {
                 let ret = res.data
                //帮电商解决 teldappid问题
                 if(TELDAppID!=''&&window.location.hostname.indexOf('newmall')!=-1){
                     createCookie('TELDAppID',TELDAppID,1200)
                 }
                 //成功未必有返回值
                 if (ret == null || ret == "") {
                     if (opts.success) {
                         opts.success(ret)
                     }
                     return
                 }
                 //异常
                 if ((ret.hasOwnProperty("ErrorCode") && ret.ErrorCode) || (ret.hasOwnProperty("errcode") && ret.errcode)) {
 
                     let ErrorCode = ret.hasOwnProperty("ErrorCode") ? ret.ErrorCode : ret.errcode
                     let ErrorInfo = ret.hasOwnProperty("ErrorInfo") ? ret.ErrorInfo : ret.errmsg
 
                     if (isInApp) {
                         if (ErrorCode == 'TTP-SG-1001') {
                             eraseCookie('twf_deviceInfo')
                             return goLogin(ret)
                         } else if (ErrorCode == "TTP-SG-1013" || ErrorCode == "TTP-SG-1011" || ErrorCode == "TTP-Security-0002") {
                             eraseCookie('twf_deviceInfo')
                             return monRefreshToken(function () {
                                 apiAxiosRetry(opt, ErrorCode)
                             }, ret, data)
                         } else if (ErrorCode == "TTP-SG-2003") {
                             eraseCookie('twf_deviceInfo')
                             return apiAxiosRetry(opt, ErrorCode)
                         }
                     } else if (ErrorCode == "TTP-SG-1001" || ErrorCode == 'TTP-SG-1013') {
                         if (!opt.noIdentity) goLogin(ret)
                     } else if (ErrorCode == "TTP-SG-1011" || ErrorCode == "TTP-Security-0002") { // Token过期
                         //校验IP不一致
                         if (ErrorInfo && ErrorInfo.indexOf("IP不一致") != -1) {
                             if (readCookie('telda')) {
                                 // alert("客户端IP发生变化，请重新登陆！")
                                 if (opt.noIdentity) {
                                     eraseCookie('telda')
                                     return apiAxios(opt)
                                 } else {
                                     goLogin(ret)
                                 }
                             } else {
                                 await aLogin()
                                 return apiAxios(opt)
                             }
                         } else {
                             return monRefreshToken(function () {
                                 apiAxiosRetry(opt, ErrorCode)
                             }, ret, data)
                         }
                     } else if (ErrorCode == "TTP-SG-2003") { // 时间戳不整合
                        let TTT =0
                        if(ErrorInfo.indexOf(':')>0){
                           TTT = new Number(ErrorInfo && ErrorInfo.split(":")[1])
                        }
                         setTimeDif(TTT);
                         return apiAxiosRetry(opt, ErrorCode)
                     }
                     if (isFunction(opts.failure)) {
                         return opts.failure(ret)
                     }
                 } else {
                     if (isInApp && appVersion >= '4.1.0') {
                         try {
                             let retCache = void 0
                             if (typeof ret == 'object') retCache = JSON.parse(JSON.stringify(ret))
                             else retCache = ret
                             Teld.teldSGCacheControl({
                                 sid: opts.url,
                                 respJson: retCache
                             })
                         } catch (e) {
                             console.log(e)
                         }
                     }
                     if (isCoreSG && ret.data) {
                         ret.data = dcajessOutside(ret.data)
                     }
                 }
 
                 if (res.status >= 200 && res.status < 300) {
                     isFunction(opts.success) && opts.success(ret)
                 } else {
                     isFunction(opts.failure) && opts.failure(ret)
                 }
 
             }
         )
         .catch(function (err) {
             console.log(err)
             //帮电商解决 teldappid问题
             if(TELDAppID!=''&&window.location.hostname.indexOf('newmall')!=-1){
                 createCookie('TELDAppID',TELDAppID,1200)
             }
             if (!err) return
             try {
                 let res = err && err.response && err.response.data
                 isFunction(opts.failure) && opts.failure(res)
             } catch (e) {
                 console.log(e)
             }
         })
 }
 
 function initOptions(method, url, data, success, failure) {
     let opts = {
         method: method,
         url: url,
         data: data,
         success: success,
         failure: failure
     }
     return opts
 }
 
 async function isLogin() {
     if (readCookie('telda')) {
         return true
     } else if (readCookie('teldb')) {
         await refreshToken()
         if (readCookie('telda')) {
             return true
         }
     }
     return false
 }
 
 function decode64(input) {
     var output = "";
     var chr1, chr2, chr3 = "";
     var enc1, enc2, enc3, enc4 = "";
     var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
     var i = 0;
 // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
     var base64test = /[^A-Za-z0-9\+\/\=]/g;
     if (base64test.exec(input)) {
         console.log("There were invalid base64 characters in the input text.\n" +
             "Valid base64 characters are A-Z, a-z, 0-9, '+', '/', and '='\n" +
             "Expect errors in decoding.");
     }
     input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
     do {
         enc1 = keyStr.indexOf(input.charAt(i++));
         enc2 = keyStr.indexOf(input.charAt(i++));
         enc3 = keyStr.indexOf(input.charAt(i++));
         enc4 = keyStr.indexOf(input.charAt(i++));
         chr1 = (enc1 << 2) | (enc2 >> 4);
         chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
         chr3 = ((enc3 & 3) << 6) | enc4;
         output = output + String.fromCharCode(chr1);
         if (enc3 != 64) {
             output = output + String.fromCharCode(chr2);
         }
         if (enc4 != 64) {
             output = output + String.fromCharCode(chr3);
         }
         chr1 = chr2 = chr3 = "";
         enc1 = enc2 = enc3 = enc4 = "";
     } while (i < input.length);
     return unescape(output);
 }
 
 
 async function wxAnonymousLogin(code) {
     let MPType = readCookie('TELD_MPType') || '1'
     let AppID = readCookie('TELD_MPType') == '2' ? MALLAPPID : TELDAPPID
     let data = {
         loginInfo: JSON.stringify({
             'AuthCode': code,
             'MPType': MPType, // "公众号类型，1：特来电官方微信公众号，2：特来电商城公众号",
             'AppID': AppID,
             'DeviceType': 'WEB',
             'PrimarySource': '01',
             'SecondarySource': '0101'
         })
     }
     let loginState = ''
     await apiAxios({
         url: 'UserAPI-MP-SAuthLogin',
         data: data,
         isCoreSG: true,
         success: (res) => {
             if (res.state == '1') {
                 let realData = res.data
                 let rToken = realData.RefreshToken.split(".").reverse().join(".")
                 createCookie("telda", realData.AccessToken, realData.ExpiresIn);
                 createCookie("teldb", rToken, lon);
                 createCookie("teldc", realData.TokenType, lon);
                 createCookie("teldz", realData.ClientIP, lon);
                 loginState = '1'
             } else if (res.errcode == 'BIZ-User-0029') {
                 loginState = '2'
             } else {
                 loginState = '0'
             }
         },
         failure: () => {
             loginState = '0'
         }
 
     })
     return loginState
 }
 
 // 添加请求拦截器
 axios.interceptors.request.use(function (config) {
     // 在发送请求之前做些什么
     isFunction(axiosIntercept.request) && axiosIntercept.request(config);
     return config;
 }, function (error) {
     // 对请求错误做些什么
     return Promise.reject(error);
 });
 
 // 添加响应拦截器
 axios.interceptors.response.use(function (response) {
     // 对响应数据做点什么
     isFunction(axiosIntercept.response) && axiosIntercept.response(response.data);
     return response;
 }, function (error) {
     // 对响应错误做点什么
     return Promise.reject(error);
 });
 
 // 返回在vue模板中的调用接口
 export default {
     get: function (url, data, success, failure) {
         let opts = initOptions('GET', url, data, success, failure)
         return apiAxios(opts)
     },
     post: function (url, data, success, failure) {
         let opts = initOptions('POST', url, data, success, failure)
         return apiAxios(opts)
     },
     ajax: function (opt) {
         return apiAxios(opt)
     },
     isLogin,
     refreshToken,
     axiosIntercept,//拦截器
     wxAnonymousLogin//微信匿名登陆
 }
 


// WEBPACK FOOTER //
// ./node_modules/teld-web-component/lib/ajax.js